import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { serviceAreas } from "../mock";
import ZipChecker from "./ZipChecker";

const ServiceAreas = ({ showAll = false }) => {
  const cities = showAll ? serviceAreas : serviceAreas.slice(0, 18);
  return (
    <section className="bg-brand-slate py-20 relative overflow-hidden" id="service-areas">
      <div className="absolute inset-0 bg-gradient-to-br from-brand-navy to-brand-slate" />
      <div className="relative max-w-6xl mx-auto px-6 text-center">
        <p className="text-brand-orange font-semibold tracking-[0.18em] text-sm uppercase mb-3">
          Service Areas
        </p>
        <h2 className="font-display font-extrabold text-white text-3xl md:text-4xl">
          Proudly Serving Northern Virginia, D.C. & Maryland
        </h2>
        <div className="w-20 h-1 bg-brand-orange rounded-full mx-auto mt-4 mb-8" />

        <div className="mb-10">
          <ZipChecker variant="dark" />
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {cities.map((c) => (
            <Link
              key={c.slug}
              to={`/service-areas/${c.slug}`}
              className="inline-flex items-center gap-1.5 bg-white/8 border border-white/15 text-white/90 rounded-full px-4 py-2 text-sm hover:bg-brand-orange hover:border-brand-orange hover:text-white transition-colors"
            >
              <MapPin className="w-3.5 h-3.5 text-brand-orange" />
              {c.name}
            </Link>
          ))}
        </div>

        {!showAll && (
          <Link
            to="/service-areas"
            className="inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangedark text-white font-semibold px-7 py-3.5 rounded-full shadow-lg transition-all hover:-translate-y-0.5"
          >
            View All Service Areas
            <ArrowRight className="w-5 h-5" />
          </Link>
        )}
      </div>
    </section>
  );
};

export default ServiceAreas;
